<template>
  <div
    class="flex flex-wrap items-center justify-between text-xs"
  >
    <div class="text-background-fg/70">
      {{ label }}
    </div>

    <div
      :class="large ? 'text-xl font-bold' : 'font-semibold'"
    >
      {{ formattedValue }}
    </div>
  </div>
</template>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()

// This should really be a type union to limit typeof props.value depending on props.type
// but not possible in vue 3.2.
const props = defineProps<{
  label: string
  value: number | string | Date
  type?: "currency" | "date" | "time"
  large?: boolean
}>()

const formattedValue = computed(() => {
  if (typeof props.value === "string") {
    return props.value
  }

  if (props.value instanceof Date) {
    return props.type === "time"
      ? formatToTime(props.value)
      : formatToDate(props.value)
  }

  return props.type === "currency"
    ? formatToMerchantCurrencyString(props.value)
    : props.value
})
</script>
